import Image from 'next/image';
import { i18n } from 'next-i18next';

import Button from '@/components/Button';
import LeadButton from '@/components/LeadButton';

interface IProps {
  reverse?: boolean;
  title?: string;
  subTitle?: string;
  imgUrl?: string;
  mobileImgUrl?: string;
  btnName?: string;
  linkUrl?: string;
  ga?: string;
  ga4?: string;
}
const ClassFeature = ({ btnName, imgUrl, mobileImgUrl, reverse, title, subTitle, linkUrl, ga, ga4 }: IProps) => {
  const getButton = (options: any) => {
    if (btnName) {
      if (linkUrl && i18n?.language === 'zh') {
        return (
          <Button
            href={linkUrl}
            size="xl"
            target="_blank"
            theme="english-dashed"
            {...options}
            traceName={ga}
            traceGa4Name={ga4}
          >
            <span className="whitespace-nowrap bg-[linear-gradient(88deg,#8642F8_35.47%,#C740E8_98.37%)] bg-clip-text text-transparent">
              {btnName}
            </span>
          </Button>
        );
      }
      return (
        <LeadButton subject="english" size="xl" theme="english-dashed" traceName={ga} traceGa4Name={ga4} {...options}>
          <span className="whitespace-nowrap bg-[linear-gradient(88deg,#8642F8_35.47%,#C740E8_98.37%)] bg-clip-text text-transparent">
            {btnName}
          </span>
        </LeadButton>
      );
    }

    return null;
  };
  let content = (
    <div className="hidden items-center lg:mb-[63.86px] lg:flex xl:mb-[80px] xl:flex">
      <div className="relative flex shrink-0 items-center overflow-hidden lg:mr-[40px] lg:w-[440px]  lg:w-[440px] xl:mr-[80px] xl:w-[560px] xl:rounded-[36px]">
        <Image
          src={imgUrl as string}
          width={560}
          height={360}
          className="lg:rounded-[24px] xl:rounded-[36px]"
          alt={title as string}
        />
      </div>
      <div>
        <h3 className="font-bold text-wk-words-1 lg:mb-[12px] lg:text-[20px] xl:mb-[16px] xl:text-[28px]">{title}</h3>
        <p
          className="font-normal text-wk-words-2 lg:mb-[20px] lg:text-sm/[22px] xl:mb-[40px] xl:text-[18px] xl:leading-[32px]"
          dangerouslySetInnerHTML={{ __html: subTitle || '' }}
        />
        {getButton({
          className:
            'lg:!px-[40px] lg:!py-[12px] xl:!px-[60px] xl:!py-[16px] [&]:text-base/normal [&]:xl:text-xl/normal',
        })}
      </div>
    </div>
  );
  if (reverse) {
    content = (
      <div className="hidden items-center lg:mb-[63.86px] lg:flex xl:mb-[80px] xl:flex">
        <div>
          <h3 className="font-bold text-wk-words-1 lg:mb-[12px] lg:text-[20px] xl:mb-[16px] xl:text-[28px]">{title}</h3>
          <p
            className="font-normal text-wk-words-2 lg:mb-[20px] lg:text-sm/[22px] xl:mb-[40px] xl:text-[18px] xl:leading-[32px]"
            dangerouslySetInnerHTML={{ __html: subTitle || '' }}
          />
          {getButton({
            className:
              'lg:!px-[40px] lg:!py-[12px] xl:!px-[60px] xl:!py-[16px] [&]:text-base/normal [&]:xl:text-xl/normal',
          })}
        </div>
        <div className="relative shrink-0 overflow-hidden lg:ml-[60px] lg:w-[440px] xl:ml-[80px] xl:w-[560px] xl:rounded-[36px]">
          <Image
            src={imgUrl as string}
            width={560}
            height={360}
            className="lg:rounded-[24px] xl:rounded-[36px]"
            alt={title as string}
          />
        </div>
      </div>
    );
  }
  return (
    <>
      {content}
      {/* mobile */}
      <div className="mb-[.39rem] lg:hidden xl:hidden">
        <div className="overflow-hidden ">
          <Image
            src={mobileImgUrl || imgUrl || ''}
            width={375}
            height={250}
            className="rounded-[1.5rem_1.5rem_0rem_0rem]"
            alt={title as string}
            loading="lazy"
          />
        </div>
        <div className="relative bottom-[1rem] z-10 rounded-3xl bg-white p-6 shadow-[0px_8px_30px_0px_rgba(0,0,0,0.06)]">
          <h3 className="text-xl/normal font-semibold text-wk-words-1">{title}</h3>
          <p
            className="mb-4 mt-4 text-base font-normal text-wk-words-2"
            dangerouslySetInnerHTML={{ __html: subTitle || '' }}
          />
          <div className="text-center">
            {getButton({
              className: '[&]:text-base/normal',
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default ClassFeature;
